import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import firebase from "./Firebase";

//Building Firestore Database CRUD Web Application using React.js and Google Firebase

class App extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection("tracker"); //firestore server collection path reference
    this.unsubscribe = null;
    this.state = {
      myapps: [],
    };
  }

  //  querySnapshot fetching datas from the server and returns an ARRAY
  onCollectionUpdate = (querySnapshot) => {
    const myapps = [];
    querySnapshot.forEach((doc) => {
      const { projname, description, status, deployment } = doc.data();

      //fetching data from the server and pushing into the local empty myapps ARRAY
      myapps.push({
        key: doc.id,
        doc, // DocumentSnapshot
        projname,
        description,
        status,
        deployment,
      });
    });
    this.setState({
      myapps,
    });
    //console.log(this.state);
  };

  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }

  //Delete operation
  delete(id) {
    firebase
      .firestore()
      .collection("tracker")
      .doc(id)
      .delete()
      .then(() => {
        console.log("Document successfully deleted!");
        this.props.history.push("/");
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  }

  render() {
    return (
      <div className="container">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="text-center pt-5 pb-4 text-white">
              My Apps Tracker (CRUD)
            </h3>
            <p className="text-white text-center">
              Techonologies used: <i>React, Bootstrap, Google Firestore DB</i>
            </p>
          </div>
          <div className="panel-body">
            <h4>
              <Link to="/create" className="btn btn-primary">
                Add App
              </Link>
            </h4>
            <div
              style={{
                backgroundColor: "#ffffff",
              }}
            >
              <table className="table table-bordered">
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1f487c",
                      color: "white",
                    }}
                  >
                    <th className="border-right align-middle">Project Name</th>
                    <th className="border-right align-middle">Description</th>
                    <th className="border-right align-middle">Dev. Status</th>
                    <th className="border-right align-middle">
                      Deployed
                      <br />
                      (Yes/No)
                    </th>
                    <th className="App align-middle">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.myapps.map((app, index) => (
                    <tr key={index}>
                      <td>{app.projname}</td>
                      <td>{app.description}</td>
                      <td className="text-center">{app.status}</td>
                      <td className="text-center">{app.deployment}</td>
                      <td className="text-center">
                        <Link to={`/show/${app.key}`} className="btn btn-info">
                          View
                        </Link>
                        &#160;&#160;
                        <Link
                          to={`/edit/${app.key}`}
                          className="btn btn-success"
                        >
                          Edit
                        </Link>
                        &#160;&#160;
                        <button
                          onClick={this.delete.bind(this, app.key)}
                          className="btn btn-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
